import React from 'react'
import PropTypes from 'prop-types'

const TrainIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Train"
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512', }}
  >
    <title id="train-icon">Train</title>
    <g>
      <path
        fill={fill}
        d="M233.416,104.475c-5.615-9.046-17.5-11.826-26.545-6.211l-52.618,32.665c-4.614,2.865-7.806,7.543-8.79,12.882
        c-0.984,5.34,0.329,10.849,3.618,15.171l22.876,30.055h48.453l-27.808-36.536l34.604-21.481
        C236.251,125.405,239.031,113.52,233.416,104.475z"
      />
      <path
        fill={fill}
        d="M505.687,305.606l-12.878-16.986h-82.707c-7.098,0-12.852-5.754-12.852-12.852s5.754-12.852,12.852-12.852h63.22
        l-8.694-11.467c-14.18-18.704-34.37-31.561-56.795-36.709H0v140.72h480.921c17.164,0,31.079-13.914,31.079-31.079
        C512,317.601,509.783,311.008,505.687,305.606z M166.864,288.62h-22.247c-7.098,0-12.852-5.754-12.852-12.852
        s5.754-12.852,12.852-12.852h22.247c7.098,0,12.852,5.754,12.852,12.852S173.961,288.62,166.864,288.62z M252.886,288.62h-22.247
        c-7.098,0-12.852-5.754-12.852-12.852s5.754-12.852,12.852-12.852h22.247c7.098,0,12.852,5.754,12.852,12.852
        S259.984,288.62,252.886,288.62z M338.909,288.62h-22.247c-7.098,0-12.852-5.754-12.852-12.852s5.754-12.852,12.852-12.852h22.247
        c7.098,0,12.852,5.754,12.852,12.852S346.007,288.62,338.909,288.62z"
      />
      <path
        fill={fill}
        d="M483.472,378.083H26.119c-10.646,0-19.277,8.631-19.277,19.277c0,10.646,8.631,19.277,19.277,19.277h457.353
        c10.646,0,19.277-8.631,19.277-19.277C502.749,386.714,494.118,378.083,483.472,378.083z"
      />
    </g>
  </svg>)

TrainIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  customClassName: PropTypes.string,
  fill: PropTypes.string,
}

TrainIcon.defaultProps = {
  width: 20,
  height: undefined,
  customClassName: '',
  fill: 'blue',
}

export default TrainIcon



// WEBPACK FOOTER //
// ./src/components/icons/Train.js